<template>
	<div class="side-panel">
		<div class="p-2 active filter-type">Filter by project category</div>
		<!-- <div class="vertical-line" /> -->
		<div id="options-all" class="option inactive" @click="toggleActive">all</div>
		<!-- <div class="vertical-line render-below" /> -->
		<!--				**** DO NOT DELETE **** 
				THIS IS HOW EACH TYPE WILL BE ADDED TO THE LIST
				************************************************
			<div class="option inactive" @click="toggleActive">substations</div>
			<div class="vertical-line" />
		-->
	</div>
</template>

<script>
import emitter from '@/emitter';
import ProjectsFile from '@/content/projects.json';
export default {
	components: {
	},
	data() {
		return {
			types: new Set([...ProjectsFile.projects].sort((a,b)=>{
				return a.category.length - b.category.length;
			}).map((project)=>{
				return project.category;
			}).sort())
		};
	},
	mounted() {
		emitter.$emit('projects-filter', []);
		const parent = document.querySelector('.side-panel');
		this.types.forEach(type_selector => {
			const node_type_selector = document.createElement('DIV');
			node_type_selector.classList.add('option');
			node_type_selector.classList.add('inactive');
			node_type_selector.innerText = type_selector;

			node_type_selector.addEventListener('click', this.toggleActive);

			parent.appendChild(node_type_selector);
		});
	},
	methods: {
		toggleActive(event) {
			event.target.classList.toggle('active');
			event.target.classList.toggle('inactive');
			this.$nextTick(()=>{
				let test = event.target.innerHTML;
				let filter = [];
				if(test !== 'all') {
					document.querySelector('#options-all').classList.remove('active');
					document.querySelector('#options-all').classList.add('inactive');
					let selected = document.querySelector('.side-panel').querySelectorAll('.option.active');
					selected.forEach( element => {
						filter.push(element.innerHTML.replace(RegExp(/\W*/igm),''));
					});
				} else {
					document.querySelector('.side-panel').querySelectorAll('.option.active').forEach( element => {
						if(element.innerHTML !== 'all') {
							this.$nextTick(()=>{
								element.classList.remove('active');
								element.classList.add('inactive');
							});
						}
					});
				}
				emitter.$emit('projects-filter', filter);
			});
		}
	}
};
</script>

<style lang="scss" >
	@import '../assets/style/main.scss';
	$border-color: #2d506a;
	$animation_speed: 500ms;
	@mixin _border {
		border-color: $border-color;
		border-width: 0.15em;
		border-style: solid;
		border-radius: $border-radius-6;
	}

	@mixin unpushed {
		margin-left: 3em;
		animation-fill-mode: both;
		animation: move-div-back $animation_speed 1 both;
		@keyframes move-div-back {
			0% {
				margin-left: 5em;
			}
			100% {
				margin-left: 3em;
			}
		}

		&::before { // CIRCLE
			left: -3em;
			animation-fill-mode: both;
			animation: move-circle-back $animation_speed 1 both;
			@keyframes move-circle-back {
				0% {
					left: -5em;
				}
				100% {
					left: -3em;
				}
			}
		}
		&::after { //LINE
			left: -2em;
			width: 2em;
			animation-fill-mode: both;
			animation: grow-line-back $animation_speed 1 both;
			@keyframes grow-line-back {
				0% {
					left: -4em;
					width: 4em;
				}
				100% {
					left: -2em;
					width: 2em;
				}
			}
		}
	}
	@mixin pushed {
		margin-left: 5em;
		animation-fill-mode: both;
		animation: move-div $animation_speed 1 both;
		@keyframes move-div {
			0% {
				margin-left: 3em;
			}
			100% {
				margin-left: 5em;
			}
		}

		&::before { // CIRCLE
			left: -5em;
			animation-fill-mode: both;
			animation: move-circle $animation_speed 1 both;
			@keyframes move-circle {
				0% {
					left: -3em;
				}
				100% {
					left: -5em;
				}
			}
		}
		&::after { //LINE
			left: -4em;
			width: 4em;
			animation-fill-mode: both;
			animation: grow-line $animation_speed 1 both;
			@keyframes grow-line {
				0% {
					left: -2em;
					width: 2em;
				}
				100% {
					left: -4em;
					width: 4em;
				}
			}
		}
	}
	.side-panel {
		color: $white;

		* {
			letter-spacing: 0.1px;
		}
		
		max-width: 40ch;
		@supports (position: sticky) {
			max-width: initial;
		}

		margin: 1em 2em 0em 2em;
		.filter-type {
			text-align: left;
		}
		.option {
			float: left;
			user-select: none;
			transition: all 0.25s ease;
			text-align: center;
			@include _border();
			padding: 0.25em 1em;
			margin-left: 0.5em;
			margin-top: 0.5em;
			&:first-of-type {
				display: block;
				margin-left: 0px;
			}

			&:hover {
				cursor: pointer;
			}
			&.active {
				background-color: $white;
				color: $text-color;
			}
		}
		
	}


	@media (max-width: 767px) {
		.side-panel {
			@supports (position: sticky) {
				margin: 1em 2em 0em 2em;
				.filter-type {
					text-align: left;
				}
				.option {
					float: left;
					@include _border();
					border-radius: 3em !important;

					padding: 0.25em 1em;
					margin-left: 0.5em;
					
					margin-top: 0.5em;
					&:first-of-type {
						display: block;
						margin-left: 0px;
					}

					&:hover {
						cursor: pointer;
					}
					&.active {
						background-color: $white;
						color: $text-color;
					}
				}
			}
		}
	}
	@media (min-width: 768px) {
		.side-panel {
			@supports (position: sticky) {
				flex-grow: 0;
				margin-top : 5em;
				margin-left: 1em;
				margin-right: 1em;
				min-width: 27ch;
				width: 16.66%;
				display: flex;
				align-items: flex-start;
				flex-direction: column;

				>.filter-type {
					z-index: 0;
				}

				.option {
					&:hover {
						cursor: pointer;
						background-color: #2d506a;
						color: $white;
					}
					&.inactive {
						@include unpushed();
					}
					&.active {
						background-color: $border-color;
						color: $white;
						&::before { // CIRCLE
							background-image: url(../assets/img/svg/24px/circle_24px.svg);
							background-size: 50%;
							background-position: center center;
							background-repeat: no-repeat;	
						}
						@include pushed();
					}
					position: relative;
					border-width: 0px;
					position: relative;
					padding: 0.25em 2em;
					margin-left: 3em;
					@include _border();
					border-radius: 2.5em;
					
					margin-top: 1em;
					&:nth-of-type(2) {
						margin-top: 2em;
					}
					&:nth-of-type(n+2) {
						display: flex;
						justify-content: center;
						align-items: center;
						min-width: 20ch;
						max-width: 20ch;
						min-height: 3em;
					}
					&::before, &::after {
						position: absolute;
						content: '';
						top: 0px;
					}
					&::before { // CIRCLE
						left: -3em;
						border-radius: 50%;
						height: 0.75em;
						width: 0.75em;
						top: calc(50% - 0.6em);
						@include _border();
					}
					&::after { //LINE
						content: '';
						left: -2em;
						background-color: $border-color;
						height: 0.15em;
						width: 2em;
						top: calc(50% - 0.15em);
					}
				}
			}
		}
	}
</style>